import { IDeviceState } from './device.types'

export const DeviceState: IDeviceState = {
  isMobile: false
}
